import { render } from "./biddings-list-component.vue?vue&type=template&id=02147ea8&ts=true"
import script from "./biddings-list-component.vue?vue&type=script&lang=ts"
export * from "./biddings-list-component.vue?vue&type=script&lang=ts"

import "./biddings-list-component.vue?vue&type=style&index=0&id=02147ea8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__